export default __webpack_public_path__ + "static/education-secondary-circle-46e86c7575a4fa0088ce74b39bcea186.png";